import React, { Component } from 'react';
import { HashLink } from 'react-router-hash-link';


class Logo extends Component {
  render(){

    const src = '/imgs/paul_logo_'+(this.props.gray ? 'gray' : 'color')+'_'+(this.props.text ? 'text' : 'small')+'.svg';
    let sizeClass = 'paul-logo'+( this.props.text ? '-text' : '' )+'-'+( this.props.size || 'lg' ); // height: xs:40, sm:50, md:60, lg:80, xl:100

    let elem = (
      <div
        style={{position: 'relative', display: 'inline-block', zIndex: 2, ...this.props.style} }
        className={ (this.props.className || 'mb-4') + ' ' + sizeClass }
      >
        <img
          src={ src }
          alt="Paul Open Search Logo"
          style={{ width: '100%', height: 'auto' }}
          className={(this.props.shadow ? 'rounded-circle shadow-sm' : '')}
        />
        <img
          src="/imgs/beta_label.svg"
          alt="beta"
          style={{
            position: 'absolute',
            bottom: ( this.props.text ? '10%' : '8%'),
            right: ( this.props.text ? '62%' : '-8%'),
            width: ( this.props.text ? '15%' : '40%'),
            height: 'auto'
          }}
          className={(this.props.shadow ? 'rounded shadow' : '')}
        />
      </div>
    );

    if(this.props.link === false){
      return elem
    } else {
      return ( <HashLink to='/#top'>{ elem }</HashLink> )
    }

  }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/ui-elements/Logo.js